import { GetArchTypes, GetPurposeTypes } from '@api'

export const formItemsFun = async function () {
  const archTypes = (await GetArchTypes({})).data || []
  const purposeTypes = (await GetPurposeTypes({})).data || []
  let result = [
    {
      key: 'SubscribeType',
      type: 'radio',
      label: '查档类型',
      value: 'company',
      radios: [
        {
          value: 'user',
          label: '个人查档'
        }, {
          value: 'company',
          label: '单位查档'
        }
      ],
      onChange: val => {
        const sign = val === 'user'
        const companyName = this.formItems.find(f => f.key === 'CompanyName')
        companyName.hide = sign
        companyName.value = ''
        this.formItems.find(f => f.key === 'ArchiveQueryType').label = `查档${sign ? '人' : '单位'}类型`
      }
    }, {
      key: 'ArchiveQueryType',
      type: 'select',
      label: '查档单位类型',
      options: archTypes.map(m => ({
        value: m.KEY_1_VALUE,
        text: m.DATA_1_VALUE
      })),
      rules: {
        required: true,
        message: '必须选择类型',
        trigger: 'change'
      }
    }, {
      key: 'CompanyName',
      type: 'input',
      label: '查档人单位',
      rules: {
        required: true,
        message: '必须输入查档人单位',
        trigger: 'blur'
      }
    }, {
      key: 'UserName',
      type: 'input',
      label: '查档人姓名',
      rules: {
        required: true,
        message: '必须输入查档人姓名',
        trigger: 'blur'
      }
    }, {
      key: 'CardNo',
      type: 'input',
      label: '身份证号',
      rules: {
        required: true,
        message: '必须输入身份证号',
        trigger: 'blur'
      }
    }, {
      key: 'Phone',
      type: 'input',
      label: '移动电话',
      rules: [
        {
          required: true,
          message: '必须输入移动电话',
          trigger: 'blur'
        }, {
          pattern: /^[1]([3-9])[0-9]{9}$/,
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      key: 'EMail',
      type: 'input',
      label: '邮箱',
      rules: [
        {
          required: true,
          message: '必须输入邮箱',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的格式',
          trigger: 'blur'
        }
      ]
    }, {
      type: 'appointmentDate',
      label: '预约日期',
      date: {
        key: 'SubscribeZQDate',
        options: {
          disabledDate: date => {
            return Date.parse(date) < Date.parse(new Date())
          }
        }
      },
      select: {
        key: 'Amorpm',
        options: [
          {
            value: '1',
            text: this.$config.registerDateTo[0]
          }, {
            value: '2',
            text: this.$config.registerDateTo[1]
          }
        ]
      }
    }, {
      key: 'QueryContent',
      type: 'input',
      inputType: 'textarea',
      autosize: {
        minRows: 2
      },
      label: '查档内容',
      value: '',
      rules: {
        required: true,
        message: '必须输入查档内容',
        trigger: 'blur'
      }
    }, {
      key: 'QueryPurpose',
      type: 'select',
      label: '查档目的',
      options: purposeTypes.map(m => ({
        value: m.KEY_1_VALUE,
        text: m.DATA_1_VALUE
      })),
      rules: {
        required: true,
        message: '必须选择查档目的',
        trigger: 'change'
      }
    }, {
      key: 'Remark',
      type: 'input',
      inputType: 'textarea',
      autosize: {
        minRows: 2
      },
      label: '补充说明',
      value: '',
      maxlength: 500,
      showWordLimit: true
    }
  ]
  const { userName, userID } = this.$store.state.user
  result.map(m => {
    const { key, type } = m
    if (key === 'UserName') {
      m.value = userName
    } else if (key === 'CardNo') {
      m.value = userID
    } else if (type === 'appointmentDate') {
      m.date.value = new Date(Number(new Date()) + 1 * 24 * 60 * 60 * 1000)
      m.select.value = '1'
    }
  })
  return result
}